export const updateState = (list, stateSetter) => {
  stateSetter((prevListData) => {
    const newListData = { ...prevListData };
    list.forEach((item) => {
      newListData[item.key] = item.value;
    });
    return newListData;
  });
};
